import { useEffect } from "react";
import { useVisitorData } from "@fingerprint/react";

export default function FingerprintReporter() {
  const enabled = Boolean(process.env.REACT_APP_FINGERPRINT_API_KEY);
  const { data, error } = useVisitorData({ immediate: enabled });

  useEffect(() => {
    if (data?.visitorId || data?.visitor_id) {
      window.__SYNCOOP_VISITOR_ID__ = data.visitorId || data.visitor_id;
      if (process.env.NODE_ENV === "development") {
        console.info("[SynCoop] Fingerprint visitor id:", window.__SYNCOOP_VISITOR_ID__);
      }
    }
  }, [data]);

  useEffect(() => {
    if (error && process.env.NODE_ENV === "development") {
      console.warn("[SynCoop] Fingerprint failed:", error.message);
    }
  }, [error]);

  return null;
}
